import React from 'react';

const DanceClasses = () => {
  return (
    <div className="py-20 px-4 md:px-[192px] bg-white">

      {/* Section Header */}
      <div className='text-center mb-14'>
        <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>What We Offer</p>
        <div className='flex items-center justify-center gap-4 mb-4'>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
        </div>
        <h1 className='font-bold md:text-[48px] text-[32px] leading-tight text-gray-900' style={{ fontFamily: 'Playfair Display, serif' }}>
          Kids <span className='text-[#E40F94] italic'>Dance Classes</span>
        </h1>
        <p className='mt-4 md:text-[18px] text-[16px] text-gray-500 leading-7 max-w-3xl mx-auto'>
          🌟 We nurture young dancers by introducing them to the rich tradition of Bharatanatyam and the dynamic style of Bollywood dancing in a fun, structured, and engaging way. Our classes build a strong foundation in rhythm, movement, and expression while fostering discipline, confidence, and a love for dance. 💃
        </p>
        <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
      </div>

      {/* Level Cards */}
      <div className='flex flex-col gap-10 max-w-4xl mx-auto'>

        {/* Level 1 */}
        <div className='bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden'>
          <div className='bg-[#E40F94] px-8 py-4'>
            <p className='text-white text-[13px] uppercase tracking-[4px] font-semibold'>Beginner</p>
            <h2 className='text-white font-bold text-[28px]' style={{ fontFamily: 'Playfair Display, serif' }}>🌱 Level 1 Dance Classes</h2>
          </div>
          <div className='px-8 py-6'>
            <p className='text-[#E40F94] font-semibold text-[16px] italic mb-4'>🎉 A fun and engaging introduction to Bharatanatyam and Bollywood dancing!</p>
            <div className='space-y-3 text-gray-600 text-[16px] leading-7'>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>🙌 Designed for beginners, this class focuses on building a strong foundation in basic adavus (steps), hand gestures (mudras), and expressions (bhavas).</p>
              </div>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>🎵 Students learn proper posture, rhythm, and coordination while developing flexibility and discipline in a supportive environment.</p>
              </div>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>🌸 Dancers begin working on small dance pieces to build confidence and early stage presence.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Level 2 */}
        <div className='bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden'>
          <div className='bg-[#E40F94] px-8 py-4'>
            <p className='text-white text-[13px] uppercase tracking-[4px] font-semibold'>Intermediate</p>
            <h2 className='text-white font-bold text-[28px]' style={{ fontFamily: 'Playfair Display, serif' }}>🔥 Level 2 Dance Classes</h2>
          </div>
          <div className='px-8 py-6'>
            <p className='text-[#E40F94] font-semibold text-[16px] italic mb-4'>✨ Expanding skills and deepening understanding of Bharatanatyam and Bollywood dancing.</p>
            <div className='space-y-3 text-gray-600 text-[16px] leading-7'>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>💪 This level is for students who have mastered the basics and are ready for more complex adavus, sequences, and choreography.</p>
              </div>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>🦋 Focus is placed on improving grace, stamina, and confidence in performance.</p>
              </div>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>⚡ Students learn faster-paced choreography with greater precision while continuing to strengthen technique and expression.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Level 3 */}
        <div className='bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden'>
          <div className='bg-[#E40F94] px-8 py-4'>
            <p className='text-white text-[13px] uppercase tracking-[4px] font-semibold'>Advanced</p>
            <h2 className='text-white font-bold text-[28px]' style={{ fontFamily: 'Playfair Display, serif' }}>👑 Level 3 Dance Classes</h2>
          </div>
          <div className='px-8 py-6'>
            <p className='text-[#E40F94] font-semibold text-[16px] italic mb-4'>🏆 Refining technique and developing strong, confident performers.</p>
            <div className='space-y-3 text-gray-600 text-[16px] leading-7'>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>💫 Designed for experienced students, this level focuses on advancing intricate footwork, sharper technique, and expressive storytelling.</p>
              </div>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>🎭 Students work on complex adavu combinations, musicality, and performance quality with an emphasis on abhinaya (expressions) and stage presence.</p>
              </div>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>🌟 Dancers prepare polished group pieces and may be introduced to solo opportunities and featured roles in performances.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Elite */}
        <div className='bg-white rounded-2xl shadow-xl border-2 border-[#E40F94] overflow-hidden'>
          <div className='bg-gradient-to-r from-[#E40F94] to-[#9b0a66] px-8 py-4'>
            <p className='text-white text-[13px] uppercase tracking-[4px] font-semibold'>By Evaluation</p>
            <h2 className='text-white font-bold text-[28px]' style={{ fontFamily: 'Playfair Display, serif' }}>💎 Elite Performance Group</h2>
          </div>
          <div className='px-8 py-6'>
            <p className='text-[#E40F94] font-semibold text-[16px] italic mb-4'>🌟 For Level 3 dancers ready to take the next step.</p>
            <div className='space-y-3 text-gray-600 text-[16px] leading-7'>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>🎯 An advanced, evaluation-based program for Level 3 dancers ready for more challenging choreography and focused training.</p>
              </div>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>🎤 Elite dancers receive additional performance opportunities and prepare for select community performances.</p>
              </div>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>🕖 Meets Wednesdays from 7–8 PM.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Weekly Schedule */}
        <div className='bg-gray-50 rounded-2xl px-8 py-8 border border-gray-100'>
          <p className='text-[13px] uppercase tracking-[4px] text-[#E40F94] font-semibold mb-2 text-center'>Weekly Schedule</p>
          <h2 className='font-bold text-[26px] text-gray-900 text-center mb-6' style={{ fontFamily: 'Playfair Display, serif' }}>
            Every <em style={{ color: '#E40F94' }}>Wednesday</em>
          </h2>
          <div className='grid md:grid-cols-2 gap-4 text-center'>
            <div className='bg-white rounded-xl p-5 shadow-sm'>
              <p className='text-[22px] font-bold text-gray-900'>6–7 PM</p>
              <p className='text-gray-500'>Levels 1, 2 &amp; 3</p>
            </div>
            <div className='bg-white rounded-xl p-5 shadow-sm'>
              <p className='text-[22px] font-bold text-gray-900'>7–8 PM</p>
              <p className='text-gray-500'>Elite Performance Group</p>
            </div>
          </div>
          <p className='text-center text-gray-500 text-[15px] mt-6'>
            📍 2880 Broadway Bend Drive, Building 2, Pearland, TX 77584
          </p>
        </div>

      </div>
    </div>
  );
};

export default DanceClasses;